module.exports = __webpack_public_path__ + "media/images/main/botanic-b10e5ea1af4767489381c4178260d468.jpg";